import { api_configuration } from "../../../common";
import api_client_state = api_configuration.types.client_state.alan_api;
import { addMessage } from "../../front/messages";
import { createIdPathBuilderFromNode } from "../../navigation/createIdPathFromNode";
import hash = require("../dom/hash");
import { isDefined } from "../../validation";

let copyToClipboard: (value: string) => void;

function openDeeplink(deeplink_hash: string) {
	window.open(window.location.origin + window.location.pathname + "#" + deeplink_hash);
}

function copyLinkToClipboard(deeplink_hash: string) {
	if (!copyToClipboard) {
		const text_input = document.createElement("input");
		text_input.setAttribute("style", "left:-1000vw");
		document.body.appendChild(text_input);

		copyToClipboard = function (value: string) {
			text_input.value = value;
			text_input.select();
			text_input.setSelectionRange(0, text_input.value.length);
			document.execCommand("copy");
		};
	}
	copyToClipboard(window.location.origin + window.location.pathname + "#" + deeplink_hash);
}

export function view_in_new_window(view: api_client_state.Copen_views): void {
	const node = view.properties.view_context.output.result_node();
	node.properties.location.switch({
		local: function () {
			addMessage("warning", "Cannot open new window", { body: "Save the entry, then try again." });
		},
		remote: function () {
			openDeeplink(
				hash.deepLinkTo(
					isDefined(view.properties.view_definition.ref.parent.key),
					view.properties.view_definition.ref.key,
					createIdPathBuilderFromNode(node)
				)
			);
		},
	});
}

export function copy_link_to_clipboard(view: api_client_state.Copen_views): void {
	const node = view.properties.view_context.output.result_node();
	node.properties.location.switch({
		local: function () {
			addMessage("warning", "Cannot copy link", { body: "Save the entry first, then try again" });
		},
		remote: function () {
			copyLinkToClipboard(
				hash.deepLinkTo(
					isDefined(view.properties.view_definition.ref.parent.key),
					view.properties.view_definition.ref.key,
					createIdPathBuilderFromNode(node)
				)
			);
		},
	});
}
